

if (!customElements.get('stf-card')) {
  customElements.define(
    'stf-card',
    class STFCard extends HTMLElement {
      constructor() {
        super();
        // EKLENDİ: video state takibi için
        this.isPlaying = false;
      }

      get video() {
        return this.querySelector('video-element');
      }

      connectedCallback() {
  if (!this.video) return;

  // Sadece mouse cihazlarda hover eventleri ekle
  if (window.matchMedia("(pointer: fine)").matches) {
    this.addEventListener('mouseleave', this.handleMouseInteraction.bind(this, 'leave'));
    this.addEventListener('mouseenter', this.handleMouseInteraction.bind(this, 'enter'));
  }

  // Mobil için tap toggle
  if (window.matchMedia("(pointer: coarse)").matches) {
    this.addEventListener('click', this.handleTap.bind(this));
  }
}

disconnectedCallback() {
  if (window.matchMedia("(pointer: fine)").matches) {
    this.removeEventListener('mouseleave', this.handleMouseInteraction);
    this.removeEventListener('mouseenter', this.handleMouseInteraction);
  }

  if (window.matchMedia("(pointer: coarse)").matches) {
    this.removeEventListener('click', this.handleTap);
  }
}


      handleMouseInteraction(type) {
        if (!this.video) return;
        if (type === 'enter') {
          this.classList.add('is-hovering');
          this.video.play();
          // EKLENDİ: state güncelle
          this.isPlaying = true;
        } else {
          this.classList.remove('is-hovering');
          this.video.pause();
          // EKLENDİ: state güncelle
          this.isPlaying = false;
        }
      }

      // EKLENDİ: Mobilde dokunarak play/pause
      handleTap(event) {
        if (!this.video) return;

        if (window.matchMedia("(pointer: coarse)").matches) {
          if (this.isPlaying) {
            this.video.pause();
            this.classList.remove('is-hovering');
            this.isPlaying = false;
          } else {
            this.video.play();
            this.classList.add('is-hovering');
            this.isPlaying = true;
          }
          event.stopPropagation();
        }
      }
    }
  );
}

if (!customElements.get('shop-the-feed')) {
  customElements.define(
    'shop-the-feed',
    class ShopTheFeed extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.shop-the-feed__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems > 3 ? 3 : this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          // EKLENDİ: Swipe (slideChange) sırasında videoları durdur
          on: {
            slideChange: () => {
              const slides = this.sliderInstance.slider.slides;
              slides.forEach(slide => {
                const video = slide.querySelector("video-element");
                if (video && !slide.classList.contains("swiper-slide-active")) {
                  video.pause();
                  slide.classList.remove("is-hovering");
                  if (slide.closest("stf-card")) {
                    slide.closest("stf-card").isPlaying = false;
                  }
                }
              });
            }
          }
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance && this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}

// EKLENDİ: IntersectionObserver ile görünmez olunca videoyu durdur
document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll("stf-card");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const card = entry.target;
      const video = card.querySelector("video-element");

      if (!video) return;

      if (entry.isIntersecting) {
        // kullanıcı başlatmışsa devam etsin
        if (card.isPlaying) {
          video.play();
        }
      } else {
        video.pause();
        card.classList.remove("is-hovering");
        card.isPlaying = false;
      }
    });
  }, { threshold: 0.5 });

  cards.forEach(card => observer.observe(card));
});














/* 
 asagidaki kod mutation observer tarafindan cok fazla islemci tuketiyor.
bu temas olusturulurken burada video paneline pause, ekran disi video durmasi yada swipe sirasinda
video durmasi eklemedikleri icin boyle
FOX THEME PISMANLIKTIR
*/


/* =========================
   STFCard + ShopTheFeed (tam sürüm)
   - Kalıcı snapshot overlay: stf-freeze-overlay
   - Swipe/scroll/viewport değişiminde son kare korunur
   ========================= */

/*
if (!customElements.get('stf-card')) {
  customElements.define(
    'stf-card',
    class STFCard extends HTMLElement {
      constructor() {
        super();
        // Video state
        this.isPlaying = false;
        this._freezeLayer = null;

        // Bound event refs (removeEventListener için)
        this._onMouseEnter = null;
        this._onMouseLeave = null;
        this._onTap = null;
      }

      get video() {
        return this.querySelector('video-element video') || this.querySelector('video-element');
      }

      // EKLENDİ: Kalıcı dondurma katmanı (overlay)
      ensureFreezeLayer() {
        if (!this._freezeLayer) {
          const cs = getComputedStyle(this);
          if (cs.position === 'static') this.style.position = 'relative';

          const img = document.createElement('img');
          img.className = 'stf-freeze-overlay';
          Object.assign(img.style, {
              position: 'absolute',
              pointerEvents: 'none',
              display: 'none',
              zIndex: '2',
              borderRadius: '16px'
           
            });

          this.appendChild(img);
          this._freezeLayer = img;
        }
        return this._freezeLayer;
      }
          showFreeze(src) {
            const layer = this.ensureFreezeLayer();
            if (src) layer.src = src;

            // Video elementini bul
            const video = this.video;
            if (video) {
              const rect = video.getBoundingClientRect();
              const parentRect = this.getBoundingClientRect();

              // Videonun container içindeki konumunu hesapla
              const top = rect.top - parentRect.top;
              const left = rect.left - parentRect.left;

              // Overlay’i video boyutuna ve konumuna göre hizala
              layer.style.position = "absolute";
              layer.style.top = `${top}px`;
              layer.style.left = `${left}px`;
              layer.style.width = `${rect.width}px`;
              layer.style.height = `${rect.height}px`;
              layer.style.objectFit = "cover"; // Video nasıl görünüyorsa öyle dursun
            }

            layer.style.display = "block";
          }


      hideFreeze() {
        if (this._freezeLayer) this._freezeLayer.style.display = 'none';
      }

      connectedCallback() {
        if (!this.video) return;

        // Mouse cihazlarda hover eventleri
        if (window.matchMedia("(pointer: fine)").matches) {
          this._onMouseEnter = this.handleMouseInteraction.bind(this, 'enter');
          this._onMouseLeave = this.handleMouseInteraction.bind(this, 'leave');
          this.addEventListener('mouseenter', this._onMouseEnter);
          this.addEventListener('mouseleave', this._onMouseLeave);
        }

        // Mobil için tap toggle
        if (window.matchMedia("(pointer: coarse)").matches) {
          this._onTap = this.handleTap.bind(this);
          this.addEventListener('click', this._onTap);
        }
      }

      disconnectedCallback() {
        if (window.matchMedia("(pointer: fine)").matches) {
          if (this._onMouseEnter) this.removeEventListener('mouseenter', this._onMouseEnter);
          if (this._onMouseLeave) this.removeEventListener('mouseleave', this._onMouseLeave);
        }
        if (window.matchMedia("(pointer: coarse)").matches) {
          if (this._onTap) this.removeEventListener('click', this._onTap);
        }
      }

      handleMouseInteraction(type) {
        if (!this.video) return;
        if (type === 'enter') {
          this.classList.add('is-hovering');
          this.hideFreeze();             // EKLENDİ
          this.video.play();
          this.isPlaying = true;
        } else {
          this.classList.remove('is-hovering');
          this.pauseAndFreeze();
        }
      }

      // Mobilde dokunarak play/pause
      handleTap(event) {
        if (!this.video) return;

        if (window.matchMedia("(pointer: coarse)").matches) {
          if (this.isPlaying) {
            this.pauseAndFreeze();
          } else {
            this.hideFreeze();           // EKLENDİ
            this.video.play();
            this.classList.add('is-hovering');
            this.isPlaying = true;
          }
          event.stopPropagation();
        }
      }

      // Frame snapshot (pause sonrası kaldığı kareyi PNG olarak al)
     captureFrame(video) {
  try {
    const canvas = document.createElement('canvas');
    // GERÇEK çözünürlük yerine ekrandaki boyutları al
    canvas.width = video.offsetWidth;
    canvas.height = video.offsetHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/png');
  } catch (e) {
    return null;
  }
}


      // Pause + freeze (poster yerine kalıcı overlay)
      // Pause + freeze (poster yerine kalıcı overlay)
pauseAndFreeze() {
  if (!this.video) return;
  this.video.pause();

  // Sadece mobilde snapshot al
  if (window.matchMedia("(pointer: coarse)").matches) {
    const snapshot = this.captureFrame(this.video);
    if (snapshot) {
      // Poster fallback (bazı temalarda gerekebilir)
      this.video.setAttribute('poster', snapshot);
      // Kalıcı veri + overlay
      this.dataset.stickyPoster = snapshot;
      this.showFreeze(snapshot);
    }
  }

  this.isPlaying = false;
}

    }
  );
}

if (!customElements.get('shop-the-feed')) {
  customElements.define(
    'shop-the-feed',
    class ShopTheFeed extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.shop-the-feed__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems > 3 ? 3 : this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          // Swipe (slideChange) sırasında videoları durdur + kalıcı snapshot overlay
          on: {
            slideChange: () => {
              const slides = this.sliderInstance.slider.slides;
              slides.forEach(slide => {
                const video = slide.querySelector("video-element video") || slide.querySelector("video-element");
                if (video && !slide.classList.contains("swiper-slide-active")) {
                  // Video durdur
                  try { video.pause(); } catch (e) {}
                  // Snapshot al
                  let snap = null;
                  try {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth || video.clientWidth || 0;
                    canvas.height = video.videoHeight || video.clientHeight || 0;
                    if (canvas.width && canvas.height) {
                      const ctx = canvas.getContext('2d');
                      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                      snap = canvas.toDataURL('image/png');
                      // Poster fallback
                      video.setAttribute('poster', snap);
                    }
                  } catch (e) {}

                  slide.classList.remove("is-hovering");

                  const card = slide.closest("stf-card");
                  if (card) {
                    // Kalıcı overlay + data attribute
                    if (snap) {
                      card.dataset.stickyPoster = snap;
                      card.showFreeze(snap);
                    } else if (card.dataset.stickyPoster) {
                      card.showFreeze(card.dataset.stickyPoster);
                    }
                    card.isPlaying = false;
                  }
                }
              });
            }
          }
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance && this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}

// IntersectionObserver: görünmez olunca videoyu durdur + kalıcı snapshot overlay
document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll("stf-card");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const card = entry.target;
      const video = card.querySelector("video-element video") || card.querySelector("video-element");
      if (!video) return;

      if (entry.intersectionRatio >= 0.9) {
        if (card.isPlaying) {
          card.hideFreeze(); // görünür ve oynuyorsa overlay’ı kapat
          try { video.play(); } catch (e) {}
        } else if (card.dataset.stickyPoster) {
          // Oynatmıyorsak ama daha önce alınmış bir kare varsa onu göster
          card.showFreeze(card.dataset.stickyPoster);
        } else {
          // Son çare: mevcut poster varsa overlay olarak bas
          const poster = video.getAttribute('poster');
          if (poster) card.showFreeze(poster);
        }
      } else {
        // Görünürlük azaldı: dondur, snapshot al ve overlay’a yaz
        try { video.pause(); } catch (e) {}
        try {
          const canvas = document.createElement('canvas');
          canvas.width = video.videoWidth || video.clientWidth || 0;
          canvas.height = video.videoHeight || video.clientHeight || 0;
          if (canvas.width && canvas.height) {
            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            const snap = canvas.toDataURL('image/png');
            video.setAttribute('poster', snap);       // fallback
            card.dataset.stickyPoster = snap;         // kalıcı veri
            card.showFreeze(snap);                    // overlay
          }
        } catch (e) {}
        card.classList.remove("is-hovering");
        card.isPlaying = false;
      }
    });
  },  { threshold: [0, 0.25, 0.5, 0.75, 1] });

  cards.forEach(card => observer.observe(card));
});

*/